import * as React from 'react'
// libs
import ReCAPTCHA from 'react-google-recaptcha'
import { useRouter } from 'hooks/useRouter'
import { setAccessToken } from 'lib/auth'
import { useMutation } from '@apollo/client/react'
// graphql
import { AUTH_EXCHANGE_CAPTCHA_TOKEN } from 'graphql/auth/mutations'
// types
import { IAuthUserWithCredentialsResponse } from 'types/graphql'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

type ExchangeCaptchaTokenResponse = {
  authExchangeCaptchaToken: IAuthUserWithCredentialsResponse
}

export const useRecaptcha = () => {
  const router = useRouter()

  const [exchangeCaptchaToken] = useMutation<ExchangeCaptchaTokenResponse>(AUTH_EXCHANGE_CAPTCHA_TOKEN)

  const [captchaToken, setCaptchaToken] = React.useState(null)

  const recaptchaRef = React.useRef<ReCAPTCHA | null>(null)

  const handleRecaptcha = async (token: string | null): Promise<string> => {
    try {
      setCaptchaToken(token)

      const {
        data: {
          authExchangeCaptchaToken: { data }
        }
      } = await exchangeCaptchaToken({
        variables: {
          token,
          domain: router.query.domain as string
        }
      })

      setAccessToken(data?.accessToken)

      return data?.accessToken
    } catch (er) {
      console.log('[useRecaptcha.handleRecaptcha]: ', parseGraphQLErrorMessages(er))
    }
  }

  return { captchaToken, setCaptchaToken, recaptchaRef, handleRecaptcha }
}
